import { Stack, styled } from "@mui/material";

export const ViewCustomerWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        "& .MuiCard-root": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
        },
        "& .card-content": {
            padding: "0",
            display: "flex",
            flexDirection: "column",
            height: "100%",
        },
        "& .card-content:last-child": {
            paddingBottom: "0",
        },
        "& .profile-images": {
            padding: "calc(var(--basic-padding)/2)",
            "& .image-box": {
                overflow: "hidden",
                flex: 1,
                border: "2px dashed var(--primary-color)",
                borderRadius: "16px",
                padding: "calc(var(--basic-padding)/4)",
                minHeight: "350px",
                "img": {
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",
                    aspectRatio: "1/1",
                    borderRadius: "8px",
                }
            }
        },
        "& .profile-images:last-child": {
            paddingBottom: "calc(var(--basic-padding)/2)",
        },
        "& .profile-information": {
            padding: "var(--basic-padding)",
        },
        "& .profile-information:last-child": {
            paddingBottom: "var(--basic-padding)",
        },
    }
})